




















import { Component, Prop, Vue } from "vue-property-decorator";
import CzPlanRow from "../cz/CzPlanRow.vue";
import CzLink from "../cz/CzLink.vue";
import GuidelineRow from "../guidelines/GuidelineRow.vue";

// The rows of one phase or day of a program: appointments, pending guidelines and active guidelines (D38: read only here).
@Component({ components: { CzPlanRow, CzLink, GuidelineRow } })
export default class ProgramColumnRows extends Vue {
  @Prop({ type: Object, required: true }) column!: any;
  @Prop({ type: Number, default: 0 }) busyId!: number;
  @Prop({ type: Boolean, default: false }) boxed!: boolean;
}
